<template>
  <v-container fluid class="pa-0">
    <div class="background-login pa-0 d-flex justify-center" style="height: 100vh">
    <v-snackbar
      v-model="showMessage"
      vertical
      bottom
      center
      :color="messageColor"
    >
      <p class="mb-0">{{ message }}</p>
    </v-snackbar>
    
        <div style="margin-top: 100px;width: 500px;min-width: 350px;" v-if="!success " flex-column flex-md-row justify-center align-center>
            <v-card style="padding: 12px;">
            <h2 class="text-center text-white">Recuperar Contraseña</h2>
            <h3 class="text-center text-white">Ingresa tu correo electrónico</h3>
            <v-row align="center" justify="center">
                <v-col cols="12">
                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                    class="d-flex flex-column flex-grow-1"
                    style="max-width: 400px; width: 100% display:flex; margin: 0 auto;"
                >
                <v-text-field
                v-model="email"
                :rules="emailRules"
                label="Correo Electrónico"
                required
                class="custom-placeholer-color text-field-custom mt-5"
              ></v-text-field>
                <v-btn
                variant="outlined"
                :disabled="!valid"
                color="primary"
                style="background: white; font-weight: 600;"
                @click="forgotPassword"
                :loading="loader"
              >
                Recuperar Contraseña
              </v-btn>
                </v-form>
                </v-col>
            </v-row> 
            </v-card>
    </div>
    <div v-else style="display: flex; align-items: center; gap: 12px;">
        <v-card style="padding: 20px;">
            <h2 class="text-center text-white">Se ha enviado un correo para restablecer tu contraseña</h2>
            <v-icon style="display:flex; font-size: 32px;" class="text-center white--text" large color="green">mdi-check-circle</v-icon>
        </v-card>
    </div>
    </div>
  </v-container>
</template>

<script>
import {  forgotPassword  } from '../../helpers/api/user'

    export default {
    name: "ForgotPassword",
    data () {
        return {
            valid: null,
            success: false,
            showMessage: false,
            messageColor: "error",
            message: "",
            email: "",
            loader: false,

            emailRules: [
            (v) => !!v || "Campo obligatorio",
            (v) => /.+@.+\..+/.test(v) || "Email debe ser válido",
        ]
        }
    },

    methods: {
    forgotPassword() {
    const data = {email: this.email}
    data.area_id = this.$store.state.area_id
    this.loader = true
    forgotPassword(data).then(res => {
        this.loader= false
        this.success = true
        this.successFormData = res.data
		}).catch(error => {
      console.log(error);
            this.loader= false
            this.message = error.response.data.message
            this.messageColor = "warning";
            this.showMessage = true;
        })
    }
    }
    }
</script>

<style scoped>
.background-login {
  background: linear-gradient(140deg,#3587c2 0%, #003153 100%) !important;
}
  .text-field-custom  {
    color: #f2f3f5;
  }
.custom-placeholer-color input::placeholder {
  color: #f2f3f5 !important;
  opacity: 1;
}

.custom-label-color .v-label {
  color: #f2f3f5 !important;
  opacity: 1;
}
.custom-label-color.v-input--error {
  color: #f2f3f5!important; /* Cor vermelha */
  caret-color: #f2f3f5!important; /* Cor do cursor vermelha */
}
</style>